export default __webpack_public_path__ + "static/media/334.ec495bca.jpg";